import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { inviteFormType } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import InviteUser from '../servicer-users/InviteUser';
import ProviderTable from './ProviderUserTable';
import { ListContainer } from 'components';

const ProviderUsers = () => {
    return (
        <ListContainer>
            <Routes>
                <Route
                    path="invite-provider"
                    element={
                        <InviteUser
                            title={texts.CREATE_PROVIDER_USER}
                            type={inviteFormType.PROVIDER}
                        />
                    }
                />
                <Route index element={<ProviderTable />} />
                <Route path="*" element={<Navigate to="/provider-users" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default ProviderUsers;
